import { motion } from "framer-motion";

const KineticText = ({ lines, baseDelay = 0.2, testIdPrefix = "kinetic-line" }) => (
  <div>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden py-1">
        <motion.div
          data-testid={`${testIdPrefix}-${i}`}
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{
            duration: 1.1,
            delay: baseDelay + i * 0.14,
            ease: [0.16, 1, 0.3, 1],
          }}
          className={line.className}
        >
          {line.text}
        </motion.div>
      </div>
    ))}
  </div>
);

export default KineticText;
